import React from "react"
import { ArrowSubmitButton, BackArrow, ReimbursementDialogFraming } from "../shared/layouts"
import { Progress } from "#/components/views/modal/Progress"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { useReimbursementContext } from "#/components/context/reimbursement/GetReimbursedContext"
import { FormattedMessage, useIntl } from "react-intl"
import { Box, DialogContentText, DialogTitle } from "@carrotfertility/carotene-core"
import { DialogActionsBar, Form, FormRadioGroup } from "@carrotfertility/carotene-core-x"
import MedicareAuLimitations from "#/components/get-reimbursed/steps/modules/MedicareAuLimitations"

export const AttestationHasPrivateInsuranceAu = (): JSX.Element => {
  const { send, back } = useStateMachine()
  const intl = useIntl()

  const { state, updateAttestationHasPrivateInsuranceAu } = useReimbursementContext()

  const canSubmit = state.attestationHasPrivateInsuranceAu != null

  const handleContinueClick = (): void => {
    send("")
  }

  const goBack = (): void => {
    updateAttestationHasPrivateInsuranceAu(null)
    back()
  }

  return (
    <>
      <Progress
        numSteps={3}
        step={2}
        label={intl.formatMessage({ defaultMessage: "About This Expense" })}
        inactiveStepBackgroundColor="#DBE6EE"
      />
      <BackArrow onClick={goBack} />
      <ReimbursementDialogFraming>
        <DialogTitle>
          <FormattedMessage defaultMessage="Do you have private insurance?" />
        </DialogTitle>
        <Box sx={{ display: "flex", flexDirection: "column", gap: (theme) => theme.tokens.spacing.lg }}>
          <DialogContentText>
            <FormattedMessage defaultMessage="We need this information to process your expense accurately." />
          </DialogContentText>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "flex-start", md: "center" }
            }}
          >
            <Form onSubmit={() => null}>
              <FormRadioGroup
                aria-labelledby="step-heading"
                name="attestationHasPrivateInsuranceAu"
                controllerProps={{ rules: { required: intl.formatMessage({ defaultMessage: "Required" }) } }}
                options={[
                  { label: intl.formatMessage({ defaultMessage: "Yes" }), value: "true" },
                  { label: intl.formatMessage({ defaultMessage: "No" }), value: "false" }
                ]}
                onChange={(e) => {
                  updateAttestationHasPrivateInsuranceAu((e.target as HTMLInputElement).value === "true")
                }}
              />
            </Form>
          </Box>
          {state.attestationHasPrivateInsuranceAu === false && <MedicareAuLimitations />}
        </Box>
      </ReimbursementDialogFraming>
      <DialogActionsBar
        primaryAction={
          <ArrowSubmitButton enabled={canSubmit} onClick={handleContinueClick}>
            <FormattedMessage defaultMessage="Continue" />
          </ArrowSubmitButton>
        }
      />
    </>
  )
}
